// this file defines hard constraints for the elements on the page, which in best case should be set from an editor in coreMedia

import { ARTICLE_OVERLAYS } from '@/services/builder/Teaser';

export const CONSTRAINTS = {
	channels: {
		viewport: {
			slider: {
				teaser: {
					articleoverlay: ARTICLE_OVERLAYS.bottomfull,
					img: {
						width: 530,
						height: 300
					}
				}
			},
			adLayout: {
				1: {
					2: {
						elements: [{ type: 'slider' }]
					},
					3: {
						elements: [{ type: 'slider' }, { type: 'ad', tagid: 'box_1' }]
					},
					4: {
						elements: [
							{ type: 'slider' },
							{
								type: 'list',
								elements: [{ type: 'teaser' }, { type: 'teaser' }, { type: 'teaser' }, { type: 'teaser' }]
							},
							{ type: 'ad', tagid: 'box_1' }
						]
					}
				},
				2: {
					2: {
						elements: [{ type: 'slider' }]
					},
					3: {
						elements: [{ type: 'slider' }, { type: 'ad', tagid: 'box_1' }]
					},
					4: {
						elements: [{ type: 'slider' }, { type: 'ad', tagid: 'box_1' }, { type: 'ad', tagid: 'box_2' }]
					}
				}
			}
		},
		Recommendation: {
			adLayout: {
				1: {
					2: {
						elements: [
							{
								type: 'list',
								elements: [{ type: 'teaser' }, { type: 'teaser' }, { type: 'teaser' }, { type: 'teaser' }]
							},
							{ type: 'ad', tagid: 'box_2' }
						]
					},
					3: {
						elements: [
							{
								type: 'list',
								elements: [{ type: 'teaser' }, { type: 'teaser' }, { type: 'teaser' }, { type: 'teaser' }]
							},
							{ type: 'ad', tagid: 'box_2' },
							{ type: 'teaser' }
						]
					},
					4: {
						elements: [
							{ type: 'ad', tagid: 'box_2' },
							{
								type: 'list',
								elements: [{ type: 'teaser' }, { type: 'teaser' }, { type: 'teaser' }, { type: 'teaser' }]
							},
							{ type: 'teaser' },
							{ type: 'teaser' }
						]
					}
				},
				2: {
					2: {
						elements: [
							{
								type: 'list',
								elements: [{ type: 'teaser' }, { type: 'teaser' }, { type: 'teaser' }, { type: 'teaser' }]
							},
							{ type: 'ad', tagid: 'box_3' }
						]
					},
					3: {
						elements: [
							{
								type: 'list',
								elements: [{ type: 'teaser' }, { type: 'teaser' }, { type: 'teaser' }, { type: 'teaser' }]
							},
							{ type: 'ad', tagid: 'box_3' },
							{ type: 'ad', tagid: 'box_4' }
						]
					},
					4: {
						elements: [
							{
								type: 'list',
								elements: [{ type: 'teaser' }, { type: 'teaser' }, { type: 'teaser' }, { type: 'teaser' }]
							},
							{ type: 'ad', tagid: 'box_3' },
							{ type: 'ad', tagid: 'box_4' },
							{ type: 'teaser' }
						]
					}
				}
			}
		},
		Games: {
			slider: {
				teaser: {
					articleoverlay: ARTICLE_OVERLAYS.bottomleft,
					img: {
						width: 960,
						height: 540
					}
				}
			}
		},
		lounge: [
			{
				channelId: 'Channel_lounge',
				normalizedChannelId: 'lounge',
				layout: 'row',
				meta: {
					name: 'lounge',
					layoutName: 'lounge',
					layoutColumns: '3col',
					trackingName: 'lounge'
				},
				elements: [
					{
						type: 'ad',
						tagid: 'oms_1'
					},
					{
						type: 'ad',
						tagid: 'oms_2'
					},
					{
						type: 'ad',
						tagid: 'oms_3'
					},
					{
						type: 'ad',
						tagid: 'oms_4'
					},
					{
						type: 'ad',
						tagid: 'oms_5'
					},
					{
						type: 'ad',
						tagid: 'oms_6'
					},
					{
						type: 'ad',
						tagid: 'oms_7'
					},
					{
						type: 'ad',
						tagid: 'oms_8'
					},
					{
						type: 'ad',
						tagid: 'oms_9'
					}
				]
			}
		]
	}
};
